export const getProjectCompletionReadiness = (tasks = []) => {
  const blockedTasks = tasks.filter((task) => task.status === "bloqueada");
  const openTasks = tasks.filter(
    (task) =>
      task.status !== "cancelada" &&
      task.status !== "completada" &&
      Number(task.progress_percentage || 0) < 100,
  );

  return {
    ready: blockedTasks.length === 0 && openTasks.length === 0,
    blockedTasks,
    openTasks,
    resolvedCount: tasks.filter(
      (task) =>
        task.status === "cancelada" ||
        task.status === "completada" ||
        Number(task.progress_percentage || 0) >= 100,
    ).length,
    totalCount: tasks.length,
  };
};

export const getArgentinaToday = () => {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Argentina/Buenos_Aires",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date());
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
};
